const $ = jQuery;
export default function EnableAriaLabelNFFields() {
	$(document).on('nfFormReady', (e, layout) => {
		const currentForm = $(layout.$el[0]);
		const FormId = currentForm.attr('id');
		$(`#${FormId}`).find('form').attr('aria-label', 'Contact Form');
		$('.nf-form-fields-required').attr('aria-hidden', true);
	});
}



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/accessibility/navigation/controllers/enable_aria_lable_nf_fields.js